import { render } from "./AutomationServicePage.vue?vue&type=template&id=16129b77"
import script from "./AutomationServicePage.vue?vue&type=script&lang=js"
export * from "./AutomationServicePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__